import React, {memo} from 'react';
import {useFindPage} from '../hooks/usePageServer';
import PropTypes from 'prop-types';
import {usePageCms} from '../hooks/usePageCms';
import Page from './Page';
import PageLoading from '../components/PageLoading';
import {useCMS} from 'tinacms';
import {useCMSBuilder} from '../contexts/CMSBuilderContext';


/**
 * prepare de cms form,
 * we don't use loadInitialValues from tina, in order to take advance of react-query cache
 * */
const ServerPageLoaded = ({slug, data, children}) => {
  usePageCms(slug, data);

  return (
    <Page>
      {children}
    </Page>
  );

};

/**
 * Find the page from the server and prepare the cms form
 * */
const ServerPage = ({slug, children}) => {
  const {_enabled} = useCMS();
  const {NotFound, PageError} = useCMSBuilder();
  const {data, isLoading, error} = useFindPage(slug, true, _enabled);

  // eslint-disable-next-line no-constant-condition
  if (isLoading) {
    return <PageLoading/>;
  }
  if (error && error.status === 404 && NotFound) {
    return <NotFound/>;
  }
  if (error) {
    return <PageError/>;
  }


  return (
    <ServerPageLoaded data={data} slug={slug}>
      {children}
    </ServerPageLoaded>
  );

};


export default memo(ServerPage);

ServerPage.propTypes = {
  children: PropTypes.any,
  slug: PropTypes.string
};

ServerPageLoaded.propTypes = {
  children: PropTypes.any,
  data: PropTypes.any,
  slug: PropTypes.string
};
